export default "/048cb1f2b29308e18768c65cfd51e426596a830c/72a061e4da900bb3a21b7904c48e0b41.svg";